import * as angular from "angular";
import {IController} from "angular";
import {ProcessTrackingStatus} from "../../types/process-tracking-status.enum";

export class CustomOrderPlanningMonitorTableComponent implements IController {

  infiniteScroll: any;

  constructor() {
  }

  $onInit() {
    // Initialize component
  }

  // Helper methods for displaying data
  getProcessStatusClass(status: string): string {
    switch (status) {
      case ProcessTrackingStatus.COMPLETED:
        return 'status-completed';
      case ProcessTrackingStatus.IN_PROGRESS:
        return 'status-in-progress';
      case ProcessTrackingStatus.FAIL:
        return 'status-failed';
      default:
        return '';
    }
  }

  getProcessStatusIcon(status: string): string {
    switch (status) {
      case ProcessTrackingStatus.COMPLETED:
        return 'check-circle';
      case ProcessTrackingStatus.IN_PROGRESS:
        return 'progress-clock';
      case ProcessTrackingStatus.FAIL:
        return 'error-outline';
      default:
        return 'help-circle';
    }
  }
}

angular
  .module('bringoz.admin.order-planning-configuration')
  .component('customOrderPlanningMonitorTable', {
    bindings: {
      infiniteScroll: '<?',
    },
    template: require('./custom-order-planning-monitor-table.html').default,
    controller: CustomOrderPlanningMonitorTableComponent,
    controllerAs: '$ctrl'
  });
